module.exports = __webpack_public_path__ + "img/icons-list-3.69b71852.png";